import {LIFE_STATUS_NAMES} from "Core/Constant";

export class LifeStatuses {
	static Enabled = new LifeStatuses(LIFE_STATUS_NAMES.ENABLED);
	static Disabled = new LifeStatuses(LIFE_STATUS_NAMES.DISABLED);

	private readonly _name: string;

	private constructor(name: string) {
		this._name = name;
	}

	get Name() {
		return this._name;
	}

	static GetAll() {
		return [
			LifeStatuses.Enabled.Name,
			LifeStatuses.Disabled.Name
		];
	}
}